import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMyPrograms, getMyResources } from "../../services/growth_api";

// Async thunk for fetching programs
export const fetchMyPrograms = createAsyncThunk("myPrograms/fetchMyPrograms", async () => {
  const response = await getMyPrograms();
  return response.response.programs; 
});
// Async thunk for fetching programs
export const fetchMyResources = createAsyncThunk("myPrograms/fetchMyResources", async () => {
  const resources = await getMyResources();
  return resources; 
});

const growthSlice = createSlice({
  name: "growth",
  initialState: {
    myPrograms: [], // Ensure this matches your selector
    myResources: [], // Ensure this matches your selector
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyPrograms.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyPrograms.fulfilled, (state, action) => {
        state.loading = false;
        state.myPrograms = action.payload;
      })
      .addCase(fetchMyPrograms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchMyResources.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMyResources.fulfilled, (state, action) => {
        state.loading = false;
        state.myResources = action.payload;
      })
      .addCase(fetchMyResources.rejected, (state) => {
        state.loading = false;
      })


  },
});

export default growthSlice.reducer;
